/**
 * Extrait le frontmatter YAML d'un contenu Markdown.
 * @param {string} markdown - Le texte Markdown à analyser.
 * @returns {{ attributes: Object, content: string }} Un objet contenant les attributs du frontmatter et le contenu Markdown sans frontmatter.
 */
function parseFrontmatter(markdown) {
  if (!markdown.startsWith("---")) {
    return { attributes: {}, content: markdown }
  }

  const match = markdown.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n?/)
  if (!match) {
    return { attributes: {}, content: markdown }
  }

  const attributes = {}
  const lignes = match[1].split(/\r?\n/)
  for (const ligne of lignes) {
    const sep = ligne.indexOf(":")
    if (sep === -1) continue
    const cle = ligne.slice(0, sep).trim()
    const valeur = ligne
      .slice(sep + 1)
      .trim()
      .replace(/^"|"$/g, "")
    if (cle) attributes[cle] = valeur
  }

  return {
    attributes,
    content: markdown.slice(match[0].length),
  }
}

export { parseFrontmatter }
